import { useSetRecoilState } from 'recoil';
import {login, logout, reissue} from "../../network/Endpoint";
import {authState} from "../../recoil/auth/authState";
import {getCookie, setCookie} from "../../cookie/Cookie";
import {teacherIdState, teacherNameState} from "../../recoil/teacher/teacherIdState";

export const useAuthActions = () => {
    const setAuth = useSetRecoilState(authState);
    // 로그인
    const authLoginAsync = async (data) => {
        const expires = new Date();
        expires.setDate(expires.getDate() + 10);
        try {
            const res = await login(data);
            if (res.data.status.code === 'Success') { // 성공

                setAuth(prevState => ({
                    ...prevState,
                    loginStatus: 'LOGGED_IN',
                    teacher: res.data.data.teacher,
                    token: res.data.data.token
                }));
                // 쿠키 저장
                setCookie('auth', {
                    loginStatus: 'LOGGED_IN',
                    teacher: res.data.data.teacher,
                    token: res.data.data.token
                }, { path: '/', expires: expires });
            }else if(res.data.status.code === 'TeacherCertificationIncomplete'){ // 성공
                alert(res.data.status.message);
                window.location.href = `${process.env.REACT_APP_IS_OAUTH2_LOGOUT_URL}`;
            }else{
                alert('로그인을 실패했어요.');
            }
        } catch (error) {
            console.error('LOGIN error:', error);
            alert('로그인을 실패했어요.');
        }
    };

    // 로그아웃
    const authLogoutAsync = async (data) => {
        const expires = new Date();
        console.log(data);
        expires.setDate(expires.getDate() + 10);
        try {
            const res = await logout(data);
            if (res.data.status.code === 'Success') { // 성공

                setAuth({
                    loginStatus: 'LOGOUT_ALL',
                    teacher: {},
                    token: {}
                });
                setCookie('auth', {
                    loginStatus: 'LOGOUT_ALL',
                    teacher: {},
                    token: {}
                }, { path: '/', expires: expires });
            } else {
                alert('로그아웃을 실패했어요.');
            }
        } catch (error) {
            setAuth({
                loginStatus: 'LOGOUT_ALL',
                teacher: {},
                token: {}
            });
            setCookie('auth', {
                loginStatus: 'LOGOUT_ALL',
                teacher: {},
                token: {}
            }, { path: '/', expires: expires });
        }
    };

    // 토큰 재발급
    const authReissueToken = async(data) => {

        const expires = new Date();
        expires.setDate(expires.getDate() + 10);
        try {
            const res = await reissue(data);
            if (res.data.status.code === 'Success') { // 재발급 성공
                const newToken = res.data.data.token;

                setAuth(prevState => ({
                    ...prevState,
                    token: newToken
                }));

                setCookie('auth', {
                    ...getCookie('auth'),
                    token: newToken
                }, { path: '/', expires: expires });

            } else {
                alert('토큰 재발급을 실패했어요. 다시 로그인해주세요.');
            }
        } catch (error) {
            console.error('TOKEN REISSUE error:', error);
            alert('토큰 재발급 중 오류가 발생했어요. 다시 로그인해주세요.');
        }
    };

    return { authLoginAsync, authLogoutAsync, authReissueToken };
};
